import { ACCESSIBILITY_STORAGE_KEY, DEFAULT_STATE } from '../config/constants';

export default class StateManager {
  static load() {
    try {
      const stored = localStorage.getItem(ACCESSIBILITY_STORAGE_KEY);
      return stored ? { ...DEFAULT_STATE, ...JSON.parse(stored) } : { ...DEFAULT_STATE };
    } catch {
      return { ...DEFAULT_STATE };
    }
  }

  static save(state) {
    try {
      localStorage.setItem(ACCESSIBILITY_STORAGE_KEY, JSON.stringify(state));
    } catch {
      // Ignore errors (e.g. quota exceeded or private mode)
    }
  }

  static reset() {
    return { ...DEFAULT_STATE };
  }
}
